/* The Purpose Prints — theme behaviour.
   Cart AJAX, toasts, unit toggle, variant selection, predictive search,
   drawer, email capture, referral copy, reorder. No build step. */
(function () {
  "use strict";

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ── toast queue ──────────────────────────────────────────────── */
  var toastWrap = null;
  var toastTimer = null;
  function ensureToastWrap() {
    if (toastWrap) return toastWrap;
    toastWrap = document.createElement("div");
    toastWrap.className = "pp-toast-wrap";
    toastWrap.setAttribute("aria-live", "polite");
    document.body.appendChild(toastWrap);
    return toastWrap;
  }
  function toast(message) {
    var wrap = ensureToastWrap();
    wrap.innerHTML = '<div class="pp-toast">' + message + "</div>";
    wrap.classList.add("is-visible");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      wrap.classList.remove("is-visible");
    }, 2200);
  }
  window.PPTheme = window.PPTheme || {};
  window.PPTheme.toast = toast;

  /* ── money formatting (assumes cents, active currency already localized server-side) ── */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.theme_money_format || "£{{amount}}");
    }
    return "£" + (cents / 100).toFixed(2);
  }

  /* ── cart state + bag count ───────────────────────────────────── */
  function refreshCartChrome(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll("[data-cart-total]").forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.body.classList.toggle("pp-cart-empty", cart.item_count === 0);
  }

  function getCart() {
    return fetch(routes + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function addToCart(id, quantity, opts) {
    opts = opts || {};
    return fetch(routes + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1, properties: opts.properties }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (item) {
        return getCart().then(function (cart) {
          refreshCartChrome(cart);
          if (!opts.silent) {
            toast("Added — " + item.product_title + ", " + formatMoney(item.price));
          }
          document.dispatchEvent(new CustomEvent("pp:cart:updated", { detail: { cart: cart, item: item } }));
          return item;
        });
      })
      .catch(function (err) {
        toast((err && err.description) || "Couldn't add that to your bag.");
        throw err;
      });
  }
  window.PPTheme.addToCart = addToCart;

  function changeLine(line, quantity) {
    return fetch(routes + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        refreshCartChrome(cart);
        document.dispatchEvent(new CustomEvent("pp:cart:updated", { detail: { cart: cart } }));
        return cart;
      });
  }

  /* fetch and swap the cart items/summary partial so quantity changes,
     line removal and totals stay in sync on /cart without a full reload */
  function refreshCartSection() {
    var root = document.querySelector("[data-cart-root]");
    if (!root) return Promise.resolve();
    var sectionId = root.getAttribute("data-section-id");
    if (!sectionId) return Promise.resolve();
    return fetch(window.location.pathname + "?section_id=" + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = doc.querySelector("[data-cart-root]");
        if (next) root.innerHTML = next.innerHTML;
      });
  }

  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-cart-step]");
    if (stepBtn) {
      e.preventDefault();
      var wrap = stepBtn.closest("[data-line]");
      var line = parseInt(wrap.getAttribute("data-line"), 10);
      var valueEl = wrap.querySelector("[data-line-qty]");
      var current = parseInt(valueEl.textContent, 10) || 0;
      var next = stepBtn.getAttribute("data-cart-step") === "up" ? current + 1 : Math.max(0, current - 1);
      valueEl.textContent = next;
      stepBtn.setAttribute("disabled", "disabled");
      changeLine(line, next).then(function () {
        return refreshCartSection();
      }).finally(function () {
        stepBtn.removeAttribute("disabled");
      });
      return;
    }

    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      var line2 = parseInt(removeBtn.getAttribute("data-cart-remove"), 10);
      changeLine(line2, 0).then(refreshCartSection);
      return;
    }

    var reorderBtn = e.target.closest("[data-reorder]");
    if (reorderBtn) {
      e.preventDefault();
      var items;
      try {
        items = JSON.parse(reorderBtn.getAttribute("data-reorder"));
      } catch (err) {
        items = [];
      }
      if (!items.length) return;
      reorderBtn.setAttribute("disabled", "disabled");
      var chain = Promise.resolve();
      items.forEach(function (it) {
        chain = chain.then(function () {
          return addToCart(it.id, it.quantity || 1, { silent: true });
        });
      });
      chain
        .then(function () {
          toast("Order added to your bag");
        })
        .finally(function () {
          reorderBtn.removeAttribute("disabled");
        });
      return;
    }

    var copyBtn = e.target.closest("[data-copy-link]");
    if (copyBtn) {
      e.preventDefault();
      var text = copyBtn.getAttribute("data-copy-link");
      var original = copyBtn.textContent;
      var done = function () {
        copyBtn.textContent = "COPIED ✓";
        setTimeout(function () {
          copyBtn.textContent = original;
        }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, done);
      } else {
        done();
      }
      return;
    }

    var chip = e.target.closest("[data-search-chip]");
    if (chip) {
      e.preventDefault();
      var field = document.querySelector("[data-search-input]");
      if (field) {
        field.value = chip.getAttribute("data-search-chip");
        field.closest("form").submit();
      }
      return;
    }

    var drawerOpen = e.target.closest("[data-drawer-open]");
    if (drawerOpen) {
      e.preventDefault();
      openDrawer();
      return;
    }
    var drawerClose = e.target.closest("[data-drawer-close]");
    if (drawerClose) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var atbBarSubmit = e.target.closest("[data-atb-bar-submit]");
    if (atbBarSubmit) {
      e.preventDefault();
      var mainSubmit = document.querySelector("[data-add-to-cart-submit]");
      if (mainSubmit) mainSubmit.click();
      return;
    }
  });

  /* add-to-cart forms (product page + quick-add cards) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-add-to-cart-form]");
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var submitBtn = form.querySelector('[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : "";
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.textContent = "Adding…";
    }
    addToCart(idInput.value, 1)
      .then(function () {
        if (document.querySelector("[data-cart-root]")) return refreshCartSection();
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute("disabled");
          submitBtn.textContent = originalLabel;
        }
      });
  });

  /* email capture (Shopify customer newsletter form, submitted via AJAX) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-newsletter-form]");
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector("button");
    var originalLabel = button ? button.textContent : "";
    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    })
      .then(function () {
        if (button) button.textContent = "YOU'RE IN ✓";
        form.querySelectorAll("input[type=email]").forEach(function (i) {
          i.setAttribute("disabled", "disabled");
        });
      })
      .catch(function () {
        if (button) button.textContent = originalLabel;
        toast("Something went wrong — try again.");
      });
  });

  /* ── product-type tabs (homepage grid, shop-all sidebar/tabs) ────── */
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-type-tab]");
    if (!tab) return;
    e.preventDefault();
    var scope = tab.closest("[data-type-scope]");
    if (!scope) return;
    var type = tab.getAttribute("data-type-tab");
    scope.querySelectorAll("[data-type-tab]").forEach(function (t) {
      t.classList.toggle("is-active", t === tab);
    });
    var grid = scope.querySelector("[data-type-grid]") || document.querySelector("[data-type-grid]");
    if (!grid) return;
    var items = grid.querySelectorAll("[data-item-type]");
    var shown = 0;
    items.forEach(function (item) {
      var itemType = (item.getAttribute("data-item-type") || "").trim().toLowerCase();
      var match = type === "" || itemType === type.trim().toLowerCase();
      item.style.display = match ? "" : "none";
      if (match) shown++;
    });
    var heading = document.querySelector("[data-type-heading]");
    if (heading) heading.textContent = type || heading.getAttribute("data-type-heading-default");
    var count = document.querySelector("[data-type-count]");
    if (count) count.textContent = shown;
  });

  /* ── drawer ───────────────────────────────────────────────────── */
  function openDrawer() {
    var d = document.querySelector("[data-drawer]");
    var b = document.querySelector("[data-drawer-backdrop]");
    if (d) d.classList.add("is-open");
    if (b) b.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    var d = document.querySelector("[data-drawer]");
    var b = document.querySelector("[data-drawer-backdrop]");
    if (d) d.classList.remove("is-open");
    if (b) b.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ── unit toggle (IN / CM), persisted per visitor ────────────────── */
  var UNIT_KEY = "pp_unit";
  function getUnit() {
    try {
      return localStorage.getItem(UNIT_KEY) || "in";
    } catch (e) {
      return "in";
    }
  }
  function setUnit(unit) {
    try {
      localStorage.setItem(UNIT_KEY, unit);
    } catch (e) {}
    applyUnit(unit);
    document.dispatchEvent(new CustomEvent("pp:unit:changed", { detail: { unit: unit } }));
  }
  function applyUnit(unit) {
    document.querySelectorAll("[data-unit-toggle]").forEach(function (group) {
      group.querySelectorAll("[data-unit-option]").forEach(function (opt) {
        opt.classList.toggle("is-active", opt.getAttribute("data-unit-option") === unit);
      });
    });
    document.querySelectorAll("[data-unit-in]").forEach(function (el) {
      el.style.display = unit === "in" ? "" : "none";
    });
    document.querySelectorAll("[data-unit-cm]").forEach(function (el) {
      el.style.display = unit === "cm" ? "" : "none";
    });
  }
  document.addEventListener("click", function (e) {
    var opt = e.target.closest("[data-unit-option]");
    if (!opt) return;
    e.preventDefault();
    setUnit(opt.getAttribute("data-unit-option"));
  });

  /* Parses "10″×10″" / "21×30 cm" / "8x10 in" style option values so the
     IN/CM toggle works on real catalog data without requiring merchants to
     author a special "16×20 in|40×50 cm" convention. */
  function parseDimension(text) {
    var m = text.trim().match(/^(\d+(?:\.\d+)?)\s*(?:″|"|'{1,2}|in\.?|inch(?:es)?)?\s*[×x]\s*(\d+(?:\.\d+)?)\s*(″|"|'{1,2}|in\.?|inch(?:es)?|cm)?$/i);
    if (!m) return null;
    var unit = m[3] && /cm/i.test(m[3]) ? "cm" : "in";
    return { a: parseFloat(m[1]), b: parseFloat(m[2]), unit: unit };
  }
  function formatDimension(dim, targetUnit) {
    var a = dim.a,
      b = dim.b;
    if (dim.unit !== targetUnit) {
      if (targetUnit === "cm") {
        a = Math.round(a * 2.54);
        b = Math.round(b * 2.54);
      } else {
        a = Math.round((a / 2.54) * 10) / 10;
        b = Math.round((b / 2.54) * 10) / 10;
      }
    }
    return targetUnit === "cm" ? a + "×" + b + " cm" : a + "″×" + b + "″";
  }
  function enhanceSizeUnits(root) {
    var convertedAny = false;
    root.querySelectorAll("[data-option-name] [data-option-value]").forEach(function (btn) {
      if (btn.querySelector("[data-unit-in]")) {
        convertedAny = true;
        return;
      }
      var dim = parseDimension(btn.textContent);
      if (!dim) return;
      btn.innerHTML =
        "<span data-unit-in>" + formatDimension(dim, "in") + "</span>" +
        '<span data-unit-cm style="display:none">' + formatDimension(dim, "cm") + "</span>";
      convertedAny = true;
    });
    if (!convertedAny) {
      root.querySelectorAll("[data-unit-toggle]").forEach(function (t) {
        t.style.display = "none";
      });
    } else {
      applyUnit(getUnit());
    }
  }

  /* ── product option pickers (size / frame / variant) ─────────────── */
  function initProductForm(root) {
    var variantInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector("[data-product-price]");
    var summaryEl = root.querySelector("[data-product-summary]");
    var imgEl = root.querySelector("[data-product-hero-image]");
    var addBtn = root.querySelector("[data-add-to-cart-submit]");
    var variantsJson = root.getAttribute("data-variants");
    var variants = [];
    try {
      variants = JSON.parse(variantsJson || "[]");
    } catch (e) {}

    function selectedOptions() {
      var opts = {};
      root.querySelectorAll("[data-option-name]").forEach(function (group) {
        var active = group.querySelector(".is-active[data-option-value]");
        if (active) opts[group.getAttribute("data-option-name")] = active.getAttribute("data-option-value");
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return Object.keys(opts).every(function (k) {
          return v.options.indexOf(opts[k]) !== -1;
        });
      });
    }

    function render() {
      var opts = selectedOptions();
      var variant = matchVariant(opts);
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (summaryEl) summaryEl.textContent = variant.summary || "";
      if (imgEl && variant.featured_image) imgEl.src = variant.featured_image;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute("data-label-available") : addBtn.getAttribute("data-label-soldout");
      }
      root.querySelectorAll("[data-product-thumb]").forEach(function (t) {
        t.classList.toggle("is-active", t.getAttribute("data-product-thumb") === String(variant.id));
      });
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }

    root.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-option-value]");
      if (!opt || !root.contains(opt)) return;
      e.preventDefault();
      var group = opt.closest("[data-option-name]");
      group.querySelectorAll("[data-option-value]").forEach(function (o) {
        o.classList.remove("is-active");
      });
      opt.classList.add("is-active");
      render();
    });

    root.querySelectorAll("[data-product-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function (e) {
        e.preventDefault();
        var id = thumb.getAttribute("data-product-thumb");
        var variant = variants.find(function (v) {
          return String(v.id) === id;
        });
        if (!variant) return;
        variant.options.forEach(function (val) {
          root.querySelectorAll("[data-option-value='" + CSS.escape(val) + "']").forEach(function (o) {
            o.closest("[data-option-name]").querySelectorAll("[data-option-value]").forEach(function (x) {
              x.classList.remove("is-active");
            });
            o.classList.add("is-active");
          });
        });
        render();
      });
    });

    enhanceSizeUnits(root);
    render();
  }
  document.querySelectorAll("[data-product-form]").forEach(initProductForm);

  /* ── predictive search-as-you-type ───────────────────────────────── */
  function initSearch() {
    var input = document.querySelector("[data-search-input]");
    var grid = document.querySelector("[data-search-grid]");
    var emptyState = document.querySelector("[data-search-empty]");
    var countEl = document.querySelector("[data-search-count]");
    var typeTabs = document.querySelectorAll("[data-search-type]");
    if (!input || !grid) return;

    var activeType = "";
    typeTabs.forEach(function (tab) {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        typeTabs.forEach(function (t) {
          t.classList.remove("is-active");
        });
        tab.classList.add("is-active");
        activeType = tab.getAttribute("data-search-type");
        runSearch();
      });
    });

    var timer;
    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(runSearch, 200);
    });

    function cardHtml(p) {
      var img = p.featured_image ? p.featured_image.url || p.featured_image : p.image;
      return (
        '<a class="pp-card" href="' + p.url + '">' +
        '<div class="pp-card__frame"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
        '<div class="pp-card__name">' + p.title + "</div>" +
        '<div class="pp-card__price">' + formatMoney(p.price) + "</div>" +
        "</a>"
      );
    }

    function runSearch() {
      var q = input.value.trim();
      var url = new URL(window.location.href);
      url.searchParams.set("q", q);
      window.history.replaceState({}, "", url);
      if (!q) {
        grid.innerHTML = "";
        if (emptyState) emptyState.style.display = "none";
        if (countEl) countEl.textContent = "";
        return;
      }
      fetch(routes + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=last")
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (activeType) {
            products = products.filter(function (p) {
              return (p.product_type || "").toLowerCase() === activeType.toLowerCase();
            });
          }
          if (countEl) countEl.textContent = products.length + " results for “" + q + "”";
          if (!products.length) {
            grid.innerHTML = "";
            if (emptyState) emptyState.style.display = "";
          } else {
            if (emptyState) emptyState.style.display = "none";
            grid.innerHTML = products.map(cardHtml).join("");
          }
        });
    }

    if (input.value.trim()) runSearch();
  }
  initSearch();

  /* ── init on load ─────────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", function () {
    applyUnit(getUnit());
    getCart().then(refreshCartChrome);
  });
})();
